import React from 'react';
import { ProgressBar } from 'react-bootstrap';

type StackedProgressBarType = {
  progressCount: number;
  variant: string;
}

export default function StackedProgressBar({
  progressCount,
  variant
}: StackedProgressBarType) {
  return (
    <div className="d-flex gap-1">
      {Array.from(Array(5).keys()).map((i) => (
        <ProgressBar variant={progressCount >= i + 1 ? variant : ''} now={100} key={`stackedProgress${i}`} />
      ))}
    </div>
  );
}
